export default "__VITE_ASSET__Mwx7X01E__"